/**
 * クロス設定登録画面 クロス設定更新(リクエストパラメータ)用クラス
 *
 * @export CrossGoodsUpdate
 * @class CrossGoodsUpdate
 */
export class CrossGoodsUpdate {
  /** 受注コード */
  public orderCode = String('');
  /** クロスコード */
  public crossCode = String('');
  /** 媒体区分 */
  public mediumType = String('');
  /** クロス商品 */
  public crossGoods: { PCode: String, ChildKomaSettings: number, PublishSeq: number }[] = [];
}